import React, { useState, useEffect, useRef } from 'react';
import { Sprite, Button } from '@agissc/ktag-map';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

interface YearPickerProps {
  layers: { [key: string]: string };
  onSelectYear: (year: string) => void;
  selectedBaseMap: string;
}

export const YearPicker = ({
  layers,
  onSelectYear,
  selectedBaseMap,
}: YearPickerProps) => {
  const [selectYearIsOpen, setSelectYearIsOpen] = useState(false);
  const popupRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation('agisviewer');

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
        setSelectYearIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const onClick = () => {
    setSelectYearIsOpen(!selectYearIsOpen);
  };

  return (
    <div className="basemap-selection__year-picker-container" ref={popupRef}>
      <Button
        additionalClassNames="basemap-selection__year-picker-button"
        onClick={onClick}
      >
        <figure className="basemap-selection__button-figure" title={t('basemap_tooltip')}>
          <Sprite
            id={selectYearIsOpen ? 'chevron-up' : 'chevron-down'}
            additionalClassNames="basemap-selection__chevron"
          />
        </figure>
      </Button>
      {selectYearIsOpen && (
        <div className="basemap-selection__year-picker-content">
          <ul className="basemap-selection__year-picker-list">
            {Object.keys(layers).map((year) => (
              <li key={year}>
                <Button
                  additionalClassNames={classNames(
                    'basemap-selection__year-picker-list-item',
                    {
                      'basemap-selection__year-picker-list-item-selected':
                        layers[year] === selectedBaseMap,
                    },
                  )}
                  key={year}
                  onClick={() => {
                    setSelectYearIsOpen(false);
                    onSelectYear(year);
                  }}
                >
                  {year}
                </Button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
